
import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';

const GoogleAuthButton: React.FC = () => {
  const { login, isLoading } = useAuth();

  return (
    <Button
      onClick={login}
      disabled={isLoading}
      className="w-auto bg-white text-gray-800 hover:bg-gray-100 border border-gray-300 px-5 py-3 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md active:scale-[0.98]"
    >
      <div className="flex items-center justify-center gap-3">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.56 12.25C22.56 11.47 22.49 10.72 22.36 10H12V14.255H17.92C17.665 15.63 16.89 16.795 15.725 17.575V20.335H19.28C21.36 18.42 22.56 15.6 22.56 12.25Z" fill="#4285F4"/>
          <path d="M12 23C14.97 23 17.46 22.015 19.28 20.335L15.725 17.575C14.79 18.195 13.54 18.58 12 18.58C9.13 18.58 6.71 16.635 5.84 14H2.17V16.845C3.98 20.53 7.7 23 12 23Z" fill="#34A853"/>
          <path d="M5.84 14C5.62 13.375 5.5 12.695 5.5 12C5.5 11.305 5.62 10.625 5.84 10H2.17V12.845H5.84V14Z" fill="#FBBC05"/>
          <path d="M12 5.42C13.605 5.42 15.05 5.985 16.155 7.035L19.28 3.91C17.455 2.19 14.97 1 12 1C7.7 1 3.98 3.47 2.17 7.155L5.84 10C6.71 7.365 9.13 5.42 12 5.42Z" fill="#EA4335"/>
        </svg>
        <span className="font-medium text-base">{isLoading ? 'Signing in...' : 'Sign in with Google'}</span>
      </div>
    </Button>
  );
};

export default GoogleAuthButton;
